<template>
  <div>
    <label class="titlePage">Alterações - Candidatos</label>

    <fccTable
      striped
      hover
      responsive
      search
      pagination
      :fields="fields"
      :items="alteracoesCandidatos"
      :porPage="itemsPorPage"
    >
    </fccTable>
  </div>
</template>
<script>
import store from '../../../../../store'

export default {
  props: ['alteracoesCandidatos'],
  data() {
    return {
      dadosSelecionados: [],
      fields: [
        { key: 'idfase', label: 'Fase', sortable: true },
        { key: 'idaplic', label: 'Aplicação', sortable: true },
        { key: 'colegio', label: 'Colégio', sortable: true },
        { key: 'inscricao', label: 'Inscrição', sortable: true },
        { key: 'nome', label: 'Nome', sortable: true },
        { key: 'cpf', label: 'cpf', sortable: true },
        { key: 'tptratamento', label: 'Tipo Tratamento', sortable: true },
        { key: 'dt', label: 'Data', sortable: true }
      ],
      itemsPorPage: 10
    }
  },
  computed: {
    configuracao() {
      return store.state.localDeProva.configuracao
    }
  }
}
</script>